export default "__VITE_ASSET__DgMs6807__"